/*
  Coerce a form value to a number, treating anything that isn't finite - blank, null, a
  half-typed entry - as zero.

  Shared because a table's footer total and the figures a form computes from the same rows have
  to agree on what a blank cell is worth; agreeing by two copies of the same three lines is how
  they drift.
*/
export default function toNumber(value: unknown) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}
